import React from "react";
import LayoutOperacionesAliado from "../../components/aliadosOperaciones/LayoutOperacionesAliado";
import CobrosProgramadosAliado from "../../components/aliadosOperaciones/CobrosProgramadosAliado";

const CobrosProgramadosClienteAliado = () => (
  <LayoutOperacionesAliado title="Cobros programados">
    <CobrosProgramadosAliado />
  </LayoutOperacionesAliado>
);

export default CobrosProgramadosClienteAliado;
